<template>
  <main v-if="page" class="overflow-x-auto" :class="page.padding && [config.padding[page.padding]]">
    <cms-section v-for="section in page.sections" :key="section.name" page-context :section />
  </main>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  'change-page-title': [title: string]
}>()

const route = useRoute()
const config = useAppConfig().pages.cms
const slug = useRouteParams<string>('slug')
const childSlug = useRouteParams<string>('child_slug')
const { getUserEventData } = useAnalytics()
const { $gtm, $optimizely } = useNuxtApp()
const { getPage, getSeoMetadata } = useCms()
const { trackEvent } = useOptimizely()
const cart = useCartStore()

const localisedHelp = useLocalisedPath('/help')
const page = await getPage(`${localisedHelp.substring(1)}/${slug.value}/${childSlug.value}`)

if (page) {
  const { metadata, link } = getSeoMetadata(page)
  useSeoMeta(metadata)
  useHead(() => ({ link }))

  emit('change-page-title', metadata.title)
}

// defines markup via unhead-schema for search functionality on homepage
// https://unhead-schema-org.harlanzw.com/guide/getting-started/how-it-works
useSchemaOrg([
  defineWebSite({
    potentialAction: [
      defineSearchAction({
        target: '/search?q={search_term_string}'
      })
    ]
  })
])

onMounted(async () => {
  $gtm.queueEvent('page.onLoadPageData', route, {
    pageTitle: await getPageTitle(),
    pageCategory: 'Content',
    pageName: page?.name
  })
  const userEventData = await getUserEventData()

  $gtm.queueEvent('user.onLoadUserData', userEventData)
  $gtm.queueEvent('page.onRouterChange', route)
  $gtm.queueEvent('cart.onCartLoad', cart)
  $gtm.flushQueue()
  $optimizely?.dataReady(userEventData)
  trackEvent('page_view', { URL: route.fullPath })
})
</script>
